import styled from 'styled-components'

export { PageHeader, PageTitle } from '../pageLayoutStyles'

export const HeaderButtons = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`

export const SettingsTabsWrapper = styled.div`
  .nav-tabs {
    position: relative;
    top: auto;
    z-index: auto;
  }
`

export const TabContentWrapper = styled.div`
  margin-top: 24px;
`

export const ComingSoonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  padding: 60px 40px;
  text-align: center;
  
  .icon-wrap {
    color: #aeb4bd;
    font-size: 4rem;
    margin-bottom: 16px;
  }
  
  h3 {
    font-size: 1.25rem;
    font-weight: 600;
    color: #222;
    margin-bottom: 8px;
  }
  
  p {
    font-size: 0.875rem;
    color: #6c757d;
    max-width: 320px;
    margin: 0;
  }
`
